import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Loader2 } from "lucide-react";
import { formatApiError } from "@/lib/api";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RunbookDetail from "@/pages/RunbookDetail";
import RunbookEditor from "@/pages/RunbookEditor";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/Layout";
import "@/App.css";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

function ContributorRoute({ children }) {
  const { user, isContributor } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!isContributor) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={user === null ? <FullScreenLoader /> : <Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/runbooks/:id" element={<RunbookDetail />} />
        <Route
          path="/runbooks/:id/edit"
          element={
            <ContributorRoute>
              <RunbookEditor mode="edit" />
            </ContributorRoute>
          }
        />
        <Route
          path="/new"
          element={
            <ContributorRoute>
              <RunbookEditor mode="create" />
            </ContributorRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" theme="dark" />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
